import { REGEX_PARTS_TIME } from './constants';
import { TIME_PATTERNS } from './formatLabel';

const { HH_12, HH_24, MM, SS, SSS, AMPM, SEP, SPACE_OPT, DOT } = REGEX_PARTS_TIME;

export type TimePatternType = typeof TIME_PATTERNS[keyof typeof TIME_PATTERNS];
export type TimeFormatType = {
  regex: RegExp;
  label: TimePatternType;
  expectsMeridiem: boolean;
};

const { HH_MM_A, HHMM_A, HHA, HH_MM, HHMM, HH_MM_SS_A, HH_MM_SS, HH_MM_SS_SSS_A, HH_MM_SS_SSS } = TIME_PATTERNS;

const LEFT_BOUNDARY = '(^|\\s|[^a-zA-Z0-9])'; // start of string or non-word character
const RIGHT_BOUNDARY = '(?=$|\\s|[^a-zA-Z0-9])'; // lookahead for end of string or non-word
const pattern = (expression: string) => new RegExp(`${LEFT_BOUNDARY}${expression}${RIGHT_BOUNDARY}`, 'i');

const TimeFormatPattersType: {
  label: TimePatternType;
  regxStr: string;
  expectsMeridiem: boolean;
}[] = [
  { label: HH_MM_A, regxStr: `${HH_12}${SEP}${MM}${SPACE_OPT}${AMPM}`, expectsMeridiem: true },
  { label: HHMM_A, regxStr: `${HH_12}${MM}${SPACE_OPT}${AMPM}`, expectsMeridiem: true },
  { label: HHA, regxStr: `${HH_12}${SPACE_OPT}${AMPM}`, expectsMeridiem: true },
  { label: HH_MM, regxStr: `${HH_24}${SEP}${MM}`, expectsMeridiem: false },
  { label: HHMM, regxStr: `${HH_24}${MM}`, expectsMeridiem: false },
  { label: HH_MM_SS_A, regxStr: `${HH_12}${SEP}${MM}${SEP}${SS}${SPACE_OPT}${AMPM}`, expectsMeridiem: true },
  { label: HH_MM_SS, regxStr: `${HH_24}${SEP}${MM}${SEP}${SS}`, expectsMeridiem: false },
  {
    label: HH_MM_SS_SSS_A,
    regxStr: `${HH_12}${SEP}${MM}${SEP}${SS}${DOT}${SSS}${SPACE_OPT}${AMPM}`,
    expectsMeridiem: true,
  },
  { label: HH_MM_SS_SSS, regxStr: `${HH_24}${SEP}${MM}${SEP}${SS}${DOT}${SSS}`, expectsMeridiem: false },
];

export const TIME_FORMATS: Record<string, TimeFormatType> = Object.fromEntries(
  TimeFormatPattersType.map(({ label, regxStr, expectsMeridiem }) => [
    label,
    {
      regex: pattern(regxStr),
      expectsMeridiem,
      label,
    },
  ]),
);
